import { ReplyApi, WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto } from "../Repository/eventbookyapi";
import { addGuestReplyRequest, createReplyRequest, saveHouseholdReplyRequest, updateReplyRequest } from "../Types/RequestResponse/createReplyRequest";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class ReplyService {
    public static CreateReply = async (request: createReplyRequest) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request)
        };
        const response = await fetch(process.env.REACT_APP_API_URL + '/Reply/create', requestOptions);
        const data = await response.json();

        if (!response.ok) {
            throw Object.assign(new Error(data?.message), { status: response.status });
        }

        return data;
    };

    public static UpdateReply = async (request: updateReplyRequest) => {
        return new ReplyApi(GetApiConfiguration()).apiReplyUpdatePost({
            webApiServicesDataTransferObjectsReplyServiceUpdateReplyDto: {
                name: request.name,
                eventId: request.eventId,
                email: request.email,
                answer: request.answer,
                timeAnswers: request.timeAnswers,
                inviteId: request.inviteId,
                replyId: request.replyId,
                authCode: request.authCode
            }
        })
    };

    public static DeleteReply = async (replyId: number, message: string, sendEmail: boolean = true) => {
        return new ReplyApi(GetApiConfiguration()).apiReplyDelete({
            webApiServicesDataTransferObjectsReplyServiceDeleteReplyDto: {
                replyId: replyId,
                message: message,
                sendEmail: sendEmail,
            }
        })
    };

    public static AddMember = async (request: WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto) => {
        return new ReplyApi(GetApiConfiguration()).apiReplyAddMemberPost({
            webApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto: request
        })
    };

    // Plain fetch until the client is generated with the endpoint.
    public static AddGuest = async (request: addGuestReplyRequest) => {
        const response = await fetch(process.env.REACT_APP_API_URL + '/Reply/addGuest', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(request)
        });
        const data = await response.json();

        if (!response.ok) {
            throw Object.assign(new Error(data?.message), { status: response.status });
        }

        return data;
    };

    public static PromoteReply = async (replyId: number, timeId: number) => {
        return new ReplyApi(GetApiConfiguration()).apiReplyPromotePost({
            webApiServicesDataTransferObjectsReplyServicePromoteReplyDto: {
                replyId: replyId,
                timeId: timeId,
            }
        })
    };

    // Plain fetch so the household of a primary member's invite comes along.
    public static GetReplyByInviteIdOrAuthCode = async (eventId: string, inviteId: string, authCode: string) => {
        const query = new URLSearchParams({ EventId: eventId, InviteId: inviteId, AuthCode: authCode });
        const response = await fetch(process.env.REACT_APP_API_URL + '/Reply/GetReplyByInvite?' + query.toString());
        const data = await response.json();

        if (!response.ok) {
            throw Object.assign(new Error(data?.message), { status: response.status });
        }

        return data;
    };

    // A primary member signs up the household through the personal invite.
    public static SaveHousehold = async (request: saveHouseholdReplyRequest) => {
        const response = await fetch(process.env.REACT_APP_API_URL + '/Reply/saveHousehold', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request)
        });
        const data = await response.json();

        if (!response.ok) {
            throw Object.assign(new Error(data?.message), { status: response.status });
        }

        return data;
    };
}